import React from 'react';
import { Link } from 'react-router-dom';
import type { Breadcrumb as Interface } from '../../design/components';

/**
 * Breadcrumb - Native HTML implementation
 * Shows: Home > crumbs[0] > crumbs[1] > ...
 */
export const Breadcrumb: React.FC<Interface> = ({ crumbs = [] }) => {
  const containerStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    fontSize: '0.875rem',
    color: '#6b7280',
  };

  const linkStyle: React.CSSProperties = {
    color: '#6b7280',
    textDecoration: 'none',
  };

  const separatorStyle: React.CSSProperties = {
    color: '#9ca3af',
  };

  const currentStyle: React.CSSProperties = {
    color: '#111827',
    fontWeight: 500,
  };

  // Capitalize first letter for display
  const formatName = (name: string) => {
    return name.charAt(0).toUpperCase() + name.slice(1);
  };

  // Build path for each crumb
  const buildPath = (index: number) => '/' + crumbs.slice(0, index + 1).join('/');

  return (
    <nav style={containerStyle} aria-label="Breadcrumb">
      {crumbs.length === 0 ? (
        <span style={currentStyle}>Home</span>
      ) : (
        <Link to="/" style={linkStyle}>Home</Link>
      )}

      {crumbs.map((crumb, index) => {
        const isLast = index === crumbs.length - 1;
        const isModel = index === 0;

        return (
          <React.Fragment key={index}>
            <span style={separatorStyle}>/</span>
            {isLast ? (
              <span style={currentStyle}>{isModel ? formatName(crumb) : crumb}</span>
            ) : (
              <Link to={buildPath(index)} style={linkStyle}>
                {isModel ? formatName(crumb) : crumb}
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};
